<template>
    <div>

    </div>
</template>

<script>
import store from "@common/store";

export default {
    data() {
        return {
            beforeUnload_time: 0
        }
    },
    methods: {
        beforeunloadHandler(e) {
            this.beforeUnload_time = new Date().getTime();
        },
        unloadHandler(e) {
            let gap_time = new Date().getTime() - this.beforeUnload_time;
            if(gap_time <= 5){
                localStorage.removeItem('detailConfig')
            }
        }
    },
    destroyed() {
        // window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e))
        // window.removeEventListener('unload', e => this.unloadHandler(e))
    },
    mounted() {
        let config = JSON.parse(store.state.detailConfig)
        // let config = {
          //   type: item.type,
          //   id: item.id,
          //   quickEdit: this.config.quickEdit,
          //   create: this.config.create,
          //   canEdit: false,
          //   t: 5,
          //   d: this.config.d
          // };
          
        let data = {
            type: this.$route.query.type,
            id: this.$route.query.id,
            t: this.$route.query.t,
            d: this.$route.query.d,
            hideBack: true,
            newOpen: true
        }

        config = Object.assign({}, config, data);

        if(config.list && config.list.length > 0){
            this.$materialBox('','',config).then((e) => {
                console.log(1,e)
                if(e == 'del'){
                    window.opener.getSonData()
                    window.close()
                }else if(e == 'pic'){
                    window.opener.getSonData()
                }
            })
        }else{
            this.$materialBox(config).then((e) => {
                console.log(2,e)
                if(e == 'del'){
                    window.opener.getSonData()
                    window.close()
                }else if(e == 'pic'){
                    window.opener.getSonData()
                }
            })
        }
        console.log(config)
        // window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))
        // window.addEventListener('unload', e => this.unloadHandler(e))
        // if(!localStorage.getItem('detailConfig')){
        //     window.close()
        // }
    }
}
</script>

<style lang="less" scoped>

</style>